<template>
    <div class="shimoMobile">
        <header>数智石墨</header>
        <section class="grid-container" ref="gridContainer">
            <div
                v-for="item in menuList"
                :key="item.id"
                :class="['grid-item', item.class, {'menuItem_disable': !item.alreadyOnline}]"
                @click="openSystem(item)"
            >
                <img :src="require(`@/images/index/${item.icon}.png`)">
                <p>{{ item.name }}</p>
            </div>
        </section>
    </div>
</template>

<script>
import Sortable from 'sortablejs';
import { menuList } from '@/assets/js/systemHome.js';

export default {
    name: 'main-menu',
    components: {},
    data() {
        return {
            menuList: [],
            alreadyOnlineList: [],
        };
    },
    watch: {},
    created() {},
    mounted() {
        this.initPage();
    },
    computed: {},
    methods: {
        async initPage() {
            this.menuList = JSON.parse(JSON.stringify(menuList));
            const systemPermission = await this.getSystemPermission();
            if ((systemPermission?.userMenus[0]?.children || []).length > 0) {
                this.alreadyOnlineList = systemPermission.userMenus[0].children.map(item => item.code);
            }
            const RoleCodes = this.$takeTokenParameters('RoleCodes') || '';
            this.menuList.forEach(item => {
                if ((RoleCodes || '') !== '' && RoleCodes.includes('J10-01')) {
                    item.alreadyOnline = true;
                } else if (!this.alreadyOnlineList.includes(item.code)) {
                    item.alreadyOnline = false;
                } else {
                    item.alreadyOnline = true;
                }
            });

            const el = document.querySelector('.grid-container');
            new Sortable(el, { animation: 150, delay: 300 });
        },

        async openSystem(item) {
            if (item.alreadyOnline) {
                this.$router.isBack = 2;
                this.$router.replace({ name: 'home', params: { date: item } });
            } else {
                this.$toast.fail('暂无权限!');
            }
        },

        // 获取菜单权限
        getSystemPermission() {
            return this.$axios.$get('/interfaceApi/basicplatform/usermenu?code=smapp', { defEx: true });
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.shimoMobile
    width 100%
    background: url(./../../images/index/header.png) left 60rpx no-repeat, url(./../../images/index/bg@2x.png) center no-repeat
    background-size: 100% 30rpx, 100% 100%
    header
        padding-top: 15rpx
        font-family: YouSheBiaoTiHei;
        font-size: 30rpx;
        color: #FFFFFF;
        line-height: 75rpx;
        text-align: center;
        font-style: normal;
        background: linear-gradient(90deg, #FFFFFF 0%, #7180A7 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    section
        height calc(100% - 62rpx)
        padding 20rpx 10rpx
        .grid-item
            float left
            width: 23%
            height: 100rpx
            margin: 0 1% 34rpx
            overflow hidden
            display: flex
            justify-content: center
            flex-wrap: wrap
            &.menuItem_disable
                position relative
                &:before
                    content ''
                    position absolute
                    top 0
                    left 0
                    width 100%
                    height 100%
                    background: url(./../../images/index/lock.png), rgba(0,0,0,0.7);
                    background-size: 70px;
                    background-position: center;
                    background-repeat: no-repeat;
                    border-radius: 10px;
                    z-index 3
                    font-size: 24px
                    color rgba(255,255,255,0.7)
                    text-align center
                    line-height: 5
            img
                width 50rpx
                height: 50rpx
            p
                width 50rpx
                height 36rpx
                font-size 12rpx
                margin-top: 8rpx
                text-align: center
                color #FFFFFF
            &.xsglxt,&.cgglxt,&.ysglxt,&.ccglxt
                position: relative
                margin-left 0
                margin-right: 0
                img
                    width 100%
                p
                    position: absolute
            &.xsglxt
                width 36%
                height 140rpx
                margin-bottom: 32rpx
                img
                    height 140rpx
                    padding 0 5rpx
                p
                    width 100%
                    font-size 14rpx
                    height 44rpx
                    line-height 44rpx
                    margin-top 96rpx
            &.cgglxt
                width 64%
                height 65rpx
                margin: 0
                padding 0 5rpx
                img
                    height: 60rpx
                p
                    width calc(100% - 48rpx)
                    font-size 14rpx
                    height 60rpx
                    line-height 60rpx
                    margin-left 52rpx
                    margin-top 0
            &.ysglxt,&.ccglxt
                width 32%
                height 75rpx
                padding 0 5rpx
                img
                    height: 75rpx
                p
                    width 100%
                    font-size 12rpx
                    height 24rpx
                    line-height 24rpx
                    margin-top 48rpx
</style>
